"use client";

import { useEffect } from "react";
import { captureAssistantEvent } from "@/lib/analytics/assistant-funnel";

/** Event delegation keeps landing links server-rendered. Mounted only when
 * the portal configures analytics; editor previews do not count. */
export function AssistantFunnel() {
  useEffect(() => {
    const click = (event: MouseEvent) => {
      if (new URLSearchParams(window.location.search).get("edit") === "1") return;
      const link =
        event.target instanceof Element
          ? event.target.closest<HTMLAnchorElement>("a[data-assistant-cta]")
          : null;
      if (link)
        captureAssistantEvent("assistant_cta_clicked", {
          destination: link.dataset.assistantCta ?? "",
        });
    };
    document.addEventListener("click", click);
    return () => document.removeEventListener("click", click);
  }, []);
  return null;
}
